import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function RecentBlog() {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        axios.get('https://solanthegroup.com/admin/api/blogs')
            .then(response => {
                setBlogs(response.data);
            })
            .catch(error => {
                console.error("Error fetching recent blog posts:", error);
            });
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    return (
        <div>
            <div className="signle-side-bar recent-post">
                <div className="header">
                    <h3 className="title">Recent Post</h3>
                </div>
                <div className="body mt--50">
                    {blogs.length > 0 ? (
                        blogs.map((blog) => (
                            <div className="single-blog-recent-post-sidebar" key={blog.id}>
                                <a href="#" className="thumbnail">
                                    <div className="image-container">
                                        <img src={`https://solanthegroup.com/admin/${blog.banner}`} alt={blog.title} />
                                        <div className="overlay"></div>
                                    </div>
                                    <div className="inner">
                                        <span className="post-time">
                                            <i className="fa-regular fa-clock" />&nbsp;
                                            {formatDate(blog.created_at)}
                                        </span>
                                        <h6 className="title">
                                        {blog.title.split(" ").slice(0, 5).join(" ")}{blog.title.split(" ").length > 8 ? "..." : ""}
                                        </h6>
                                    </div>
                                </a>
                            </div>
                        ))
                    ) : (
                        <p></p>
                    )}
                </div>
            </div>
             
             <style>
                {`
                .image-container {
                    position: relative;
                    display: inline-block;
                }

                .image-container img {
                    width: 100%;
                    height: auto;
                    display: block;
                    border-radius: 5px;
                }

                .image-container .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.5); /* Black overlay with 50% opacity */
                    border-radius: 5px;
                }

                `}
             </style>
        </div>
    );
}
